import React, { useEffect } from 'react';
import { ModalTheme } from '../../../../components/modal/index.jsx';
import { FORM_TRACKING_NUMBER } from '../forms/index.js';
import { useForm } from 'react-hook-form';
import { ButtonTheme, RenderForm, TextLarge, TextSmall } from '../../../../components/index.js';
import { ContainerButton } from '../../../../styles/global-style.js';
import { shippingSelfQuery } from '../../../../services/react-query/optionMasterQuery.js';
import { useUpdateTracking } from '../hooks/useUpdateTrackNumber.js';

export const ChangeTrackNumber = ({ open, onToggle, initialValues, onFetch }) => {
  const { control, setValue, getValues, handleSubmit } = useForm({});

  const { data: shippingOptions } = shippingSelfQuery();

  useEffect(() => {
    setValue('claimId', initialValues.claimId);
    setValue('shippingId', initialValues.shippingId);
    setValue('trackingNumber', initialValues.trackingNumber);
  });

  const { mutate: updateTracking, isPending: isUpdateTrcking } = useUpdateTracking({
    onSuccessCallBack: onFetch,
  });

  const onSubmit = (value) => {
    updateTracking(value);
    onToggle({ defaultValue: [] });
  };

  return (
    <ModalTheme title=" " open={open} onToggle={onToggle} initialValues={initialValues}>
      <div style={{ textAlign: 'center', width: '100%' }}>
        <TextLarge text="แก้ไขเลขพัสดุ" />
      </div>
      <div style={{ textAlign: 'center', width: '100%' }}>
        <TextSmall text={initialValues.claimCode + ' ' + ' ' + initialValues.fullName} />
      </div>
      <RenderForm
        control={control}
        forms={FORM_TRACKING_NUMBER({ shippingOptions })}
        setValue={setValue}
        getValues={getValues}
      />
      <ContainerButton right>
        <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} isLoading={isUpdateTrcking} />
        <ButtonTheme useFor="CANCEL" onClick={onToggle} />
      </ContainerButton>
    </ModalTheme>
  );
};
